import { useEffect } from 'react'

import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useRouter } from 'next/router'

import { PageLoader } from '@/components/ui'
import { requireAuth } from '@/utils/auth/requireAuth'

import { Global } from './global'

const Index = () => {
  const router = useRouter()
  const isIPv6RedirectionEnabled = useFeatureFlag(FeatureFlag.ipv6Redirection)

  useEffect(() => {
    if (isIPv6RedirectionEnabled) {
      router.replace('/incidents')
    }
  }, [isIPv6RedirectionEnabled, router])

  if (isIPv6RedirectionEnabled) {
    return <PageLoader />
  }

  return <Global />
}

// eslint-disable-next-line import/no-default-export
export default requireAuth(Index)
